import Form from "../components/Form";
import AuthLayout from "../../../layouts/AuthLayout/AuthLayout";
import Input from "../components/Form/Input";
import Button from "../components/Form/Button";
import CheckBox from "../components/Form/CheckBox";
import { useContext, useState } from "react";
import Error from "../components/Error";
import LoadingContext from "../../../app/contexts/LoadingContext";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../api";
import useAuth from "../../../shared/hooks/useAuth";
import {loginError} from "../../../store/slices/AuthSlice";
import {toggleSelectedKey} from "../../../store/slices/SideBarSlice";
function Login() {
    const { setLoading }         = useContext(LoadingContext);
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [remember,setRemember] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const  {auth,device}   = useSelector(state => state);
    const { signIn } = useAuth();
    const handleSubmit = async () => {
        setLoading(true);
        const response = await login({
                username: username,
                password: password,
                remember: remember,
                deviceToken: device.deviceToken
        });
        if (!response.success) {
            dispatch(loginError({
                message: response.message
            }));
            if (response.errorCode === 6001){
                localStorage.setItem('deviceId', response.data.deviceId);
                navigate('/auth/verify')
            }
        }
        else {
            const data = response.data;
            console.log('Login successful, calling signIn with:', data);
            const signInResult = signIn(data);
            console.log('signIn result:', signInResult);
            dispatch(toggleSelectedKey({
                defaultSelectedKey: 'dashboard',
                defaultOpenKey: null
            }))
            navigate("/");
        }
        setLoading(false);
    }
    return (
        <AuthLayout title="Đăng nhập hệ thống" type={"login"} error={auth.login.error && <Error>{auth.login.errorMessage}</Error>}>
            <Form>
                <Input label={"Tên tài khoản"} type={"text"} onChange={(e) => setUsername(e.target.value)} />
                <Input label={"Mật khẩu"} type={"password"} onChange={(e) => setPassword(e.target.value)} />
                <CheckBox onChange={() => setRemember(!remember)}/>
                <Button onClick={handleSubmit}>Đăng nhập</Button>
            </Form>
        </AuthLayout> 
    );
} 
export default Login;